import { useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import "./style.css";
import "../../../styles/styleGlobal.css";
import { jwtDecode } from "jwt-decode";
import {
  API_ENDPOINTS,
  API_BASE_URL,
  limparSessaoEstudante,
} from "../../../js/api.js";

const Inicial = () => {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigatedRef = useRef(false);

  function validarCPF(cpf) {
    cpf = cpf.replace(/\D/g, "");
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    let soma = 0,
      resto;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) return false;

    return true;
  }

  const formatUsuario = (value) => {
    const digits = value.replace(/\D/g, "");

    if (digits.length <= 6) {
      return digits;
    }

    let cpf = digits.slice(0, 11);

    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return cpf;
  };

  const handleUsuarioChange = (e) => {
    setUsuario(formatUsuario(e.target.value));
  };

  const tentarLoginEstudante = async (config, requestBody) => {
    const {
      endpointPath,
      idField,
      storageKey,
      rotaDestino,
      rotaFallback,
      tipoPrograma,
    } = config;
    void storageKey;
    try {
      const response = await fetch(`${API_BASE_URL}${endpointPath}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json().catch(() => null);

      if (
        response.status === 401 ||
        response.status === 403 ||
        response.status === 404
      ) {
        if (response.status === 404) {
          console.error(
            `Login ${endpointPath} retornou 404`,
            data,
          );
        }
        return { kind: "rejected" };
      }

      if (!response.ok) {
        const msg = data?.errors?.[0] || data?.message
          || `Erro ao fazer login do estudante (${endpointPath}).`;
        setErrors({ user: msg });
        return { kind: "error" };
      }

      if (data?.token) {
        navigatedRef.current = true;
        localStorage.setItem("token", data.token);
        const decoded = jwtDecode(data.token);

        const usuario =
          data?.user || data?.usuario || data?.User || data?.Usuario || null;
        const tipoProgramaResp = Number(
          data?.tipo_programa ??
          usuario?.tipo_programa ??
          decoded?.tipo_programa ??
          tipoPrograma
        );

        const tcaIdResp =
          data?.tca_id ?? usuario?.tca_id ?? decoded?.tca_id ?? null;
        const tceIdResp =
          data?.tce_id ?? usuario?.tce_id ?? decoded?.tce_id ?? null;
        const tcaEmpregadorIdResp =
          data?.tca_empregador_id ??
          usuario?.tca_empregador_id ??
          decoded?.tca_empregador_id ??
          null;
        const autorizacaoGenerica =
          data?.autorizacao_id ??
          usuario?.autorizacao_id ??
          data?.[idField] ??
          data?.id_tce ??
          data?.id_tca ??
          data?.id_tca_empregador ??
          null;

        const cpfLogin = requestBody?.cpf || usuario?.cpf || decoded?.cpf || "";
        const userData = usuario
          ? {
              ...decoded,
              ...usuario,
              cpf: cpfLogin || usuario?.cpf || decoded?.cpf || "",
              documento: cpfLogin || usuario?.documento || decoded?.documento || "",
              tipo: usuario?.tipo || decoded?.tipo || "estudante",
              acesso_autorizacao: Number(
                usuario?.acesso_autorizacao ??
                decoded?.acesso_autorizacao ??
                1
              ),
              tipo_programa: Number.isFinite(tipoProgramaResp)
                ? tipoProgramaResp
                : (decoded?.tipo_programa ?? tipoPrograma ?? null),
            }
          : {
              ...decoded,
              cpf: cpfLogin || decoded?.cpf || "",
              documento: cpfLogin || decoded?.documento || "",
              tipo: decoded?.tipo || "estudante",
              acesso_autorizacao: Number(decoded?.acesso_autorizacao ?? 1),
              tipo_programa: Number.isFinite(tipoProgramaResp)
                ? tipoProgramaResp
                : (decoded?.tipo_programa ?? tipoPrograma ?? null),
            };
        localStorage.setItem("user", JSON.stringify(userData));
        if (cpfLogin) {
          localStorage.setItem("cpf_estudante", cpfLogin);
          localStorage.setItem("cpf", cpfLogin);
        }
        if (decoded?.id != null) {
          localStorage.setItem("estudante_id", String(decoded.id));
        }

        let destino = null;
        let idEscolhido = null;
        let storageKeyFinal = null;

        if (tipoProgramaResp === 1 && (tcaIdResp || autorizacaoGenerica)) {
          destino = `/tca?id=${tcaIdResp || autorizacaoGenerica}`;
          idEscolhido = tcaIdResp || autorizacaoGenerica;
          storageKeyFinal = "estudante_tca_id";
        } else if (tipoProgramaResp === 0 && (tceIdResp || autorizacaoGenerica)) {
          destino = `/tce?id=${tceIdResp || autorizacaoGenerica}`;
          idEscolhido = tceIdResp || autorizacaoGenerica;
          storageKeyFinal = "estudante_tce_id";
        } else if (
          tipoProgramaResp === 2 &&
          (tcaEmpregadorIdResp || autorizacaoGenerica)
        ) {
          destino = `/tca-empregador?id=${
            tcaEmpregadorIdResp || autorizacaoGenerica
          }`;
          idEscolhido = tcaEmpregadorIdResp || autorizacaoGenerica;
          storageKeyFinal = "estudante_tca_empregador_id";
        } else if (tipoProgramaResp === 2) {
          destino = rotaFallback || "/tca-empregador";
        } else {
          destino = rotaFallback || rotaDestino;
        }

        console.log("[LOGIN AUTORIZACAO]", {
          endpoint: endpointPath,
          status: response.status,
          tca_id: tcaIdResp,
          tce_id: tceIdResp,
          tca_empregador_id: tcaEmpregadorIdResp,
          tipo_programa: tipoProgramaResp,
          destino,
        });

        if (idEscolhido && storageKeyFinal) {
          localStorage.setItem(storageKeyFinal, String(idEscolhido));
        }

        const redirectUrl = sessionStorage.getItem("redirectAfterLogin");
        if (redirectUrl) {
          sessionStorage.removeItem("redirectAfterLogin");
          navigate(redirectUrl);
        } else {
          navigate(destino);
        }
        return { kind: "success" };
      }

      const msg = data?.errors?.[0]
        || `Erro ao fazer login do estudante (${endpointPath}).`;
      setErrors({ user: msg });
      return { kind: "error" };
    } catch (err) {
      console.error(`Erro no login do Estudante (${endpointPath}):`, err);
      return { kind: 'network' };
    }
  };

  const tentarLoginEmpresa = async (
    usuarioLimpo,
    senha,
    { silentReject = false } = {},
  ) => {
    const requestBody = { usuario: usuarioLimpo, senha };
    let response = null;
    let data = null;

    try {
      response = await fetch(API_ENDPOINTS.inicial_tokens, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });
    } catch (err) {
      console.error("Erro de rede ao chamar /tokens:", err);
      setErrors({ user: "Erro ao conectar com o servidor." });
      return { kind: "error" };
    }

    try {
      data = await response.json().catch(() => null);
    } catch (e) {
      data = null;
    }

    if (!response) {
      setErrors({ user: "Sem resposta do servidor." });
      return { kind: "error" };
    }

    if (response.status === 401 || (silentReject && response.status === 404)) {
      const userMsg =
        (data && (data.message || (data.errors && data.errors[0]))) ||
        "Credenciais inválidas ou acesso não autorizado.";
      if (silentReject) {
        return { kind: "rejected", message: userMsg };
      }
      console.error("Login 401 Unauthorized");
      setErrors({ user: userMsg });
      return { kind: "error" };
    }

    console.log("Login response", response && response.status, data);

    if (response.status === 403) {
      const userMsg =
        (data && (data.message || (data.errors && data.errors[0]))) ||
        "Usuário sem permissão de acesso. Contate o administrador.";
      if (silentReject) {
        return { kind: "rejected", message: userMsg };
      }
      console.warn("Login 403 Forbidden (acesso negado por política)");
      setErrors({ user: userMsg });
      return { kind: "error" };
    }

    if (response.status === 400) {
      let msg = "Requisição inválida (400). Verifique os campos.";
      if (data) {
        if (data.message) msg = data.message;
        else if (Array.isArray(data.errors)) {
          msg = data.errors
            .map((e) => (e && (e.message || e.msg)) || e)
            .join("; ");
        } else {
          try {
            msg = JSON.stringify(data);
          } catch (e) {
          }
        }
      }
      setErrors({ user: msg });
      return { kind: "error" };
    }

    if (response.status >= 500) {
      const msg =
        (data &&
          (data.message ||
            (data.errors && data.errors[0]) ||
            JSON.stringify(data))) ||
        "Erro interno do servidor (500). Verifique os logs do backend.";
      setErrors({ user: `Erro do servidor: ${msg}` });
      console.error("Servidor 5xx body:", data);
      return { kind: "error" };
    }

    if (response.ok && data && data.token) {
      if (navigatedRef.current) {
        return { kind: "rejected" };
      }
      navigatedRef.current = true;
      localStorage.setItem("token", data.token);
      const decoded = jwtDecode(data.token);
      const usuarioResp = data.usuario || data.user || {};
      const tipoProgramaEmpresa =
        decoded.tipo === "usuario_ciee"
          ? null
          : (decoded.tipo_programa ?? usuarioResp.tipo_programa ?? null);
      const userData = {
        ...usuarioResp,
        ...decoded,
        acesso_autorizacao:
          decoded.acesso_autorizacao ?? usuarioResp.acesso_autorizacao ?? 0,
        tipo_programa: tipoProgramaEmpresa,
      };
      localStorage.setItem("user", JSON.stringify(userData));
      console.log("User logado:", userData);
      localStorage.setItem(
        "empresa_id",
        decoded.empresa_id ?? usuarioResp.empresa_id ?? "",
      );

      const redirectUrl = sessionStorage.getItem("redirectAfterLogin");
      if (redirectUrl) {
        sessionStorage.removeItem("redirectAfterLogin");
        navigate(redirectUrl);
        return { kind: "success" };
      }

      if (decoded.tipo === "usuario_ciee") {
        localStorage.setItem("empresa_id", decoded.empresa_id || "");
        navigate("/dashboard");
        return { kind: "success" };
      }

      // Usuários externos / empresa: ao efetuar login com suas credenciais,
      // são direcionados diretamente para a tela de Acompanhamento dos seus contratos.
      navigate("/acompanhamento");
      return { kind: "success" };
    }

    setErrors({
      user: data && data.errors ? data.errors[0] : "Erro ao fazer login.",
    });
    return { kind: "error" };
  };

  const entrar = async (e) => {
    e.preventDefault();

    if (loading) return;
    setErrors({});
    setLoading(true);
    navigatedRef.current = false;

    limparSessaoEstudante();

    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("estudante_tca_id");
      localStorage.removeItem("estudante_tce_id");
      localStorage.removeItem("estudante_tca_empregador_id");
      localStorage.removeItem("estudante_id");
      localStorage.removeItem("empresa_id");
      localStorage.removeItem("ultimo_modulo_acessado");
      localStorage.removeItem("origem_modulo");
      sessionStorage.removeItem("modulo_ativo");
    } catch (_) {
    }

    try {
      let newErrors = {};

      const usuarioLimpo = usuario.replace(/\D/g, "");

      if (!usuarioLimpo) {
        newErrors.usuario = "Informe CPF ou Código da Empresa";
      }

      if (!senha) {
        newErrors.senha = "Senha em branco!";
      }

      if (usuarioLimpo) {
        if (usuarioLimpo.length === 11) {
          if (!validarCPF(usuarioLimpo)) {
            newErrors.usuario = "CPF inválido!";
          }
        } else if (usuarioLimpo.length > 6) {
          newErrors.usuario = "Código da empresa inválido";
        }
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }

      if (usuarioLimpo.length === 11 && validarCPF(usuarioLimpo)) {
        // TRELLO (2026-09-29): ordem padrão das tentativas de estudante:
        // tca-empregador → tce → tca (cai no mais recente,
        // que pra Aprendiz é o tipo 2 — TCA Empregador).
        const configsEstudante = [
          {
            endpointPath: "/tca-empregador/login-estudante",
            idField: "tca_empregador_id",
            storageKey: "estudante_tca_empregador_id",
            rotaDestino: "/tca-empregador",
            rotaFallback: "/tca-empregador",
            tipoPrograma: 2,
          },
          {
            endpointPath: "/tce/login-estudante",
            idField: "tce_id",
            storageKey: "estudante_tce_id",
            rotaDestino: "/tce",
            rotaFallback: "/tce",
            tipoPrograma: 0,
          },
          {
            endpointPath: "/tca/login-estudante",
            idField: "tca_id",
            storageKey: "estudante_tca_id",
            rotaDestino: "/tca",
            rotaFallback: "/tca",
            tipoPrograma: 1,
          },
        ];

        const redirectHint =
          sessionStorage.getItem("redirectAfterLogin") ||
          new URLSearchParams(window.location.search).get("redirect") ||
          "";

        const isRedirectEstudante =
          redirectHint.startsWith("/estudante") ||
          redirectHint.startsWith("/formulario") ||
          redirectHint.startsWith("/tca-empregador") ||
          redirectHint.startsWith("/tce") ||
          (redirectHint.startsWith("/tca") &&
            !redirectHint.startsWith("/tca-configuracoes"));

        // Se o link de origem já indica um programa específico, prioriza-o
        const matchesRota = (hint, rota) =>
          hint === rota ||
          hint.startsWith(`${rota}?`) ||
          hint.startsWith(`${rota}/`);

        const configsOrdenadas = [...configsEstudante].sort((a, b) => {
          const matchA = matchesRota(redirectHint, a.rotaDestino) ? -1 : 0;
          const matchB = matchesRota(redirectHint, b.rotaDestino) ? -1 : 0;
          return matchA - matchB;
        });

        const tentarCascataEstudante = async () => {
          for (const cfg of configsOrdenadas) {
            const res = await tentarLoginEstudante(cfg, {
              cpf: usuarioLimpo,
              senha,
            });
            if (res?.kind === "success" || res?.kind === "error") {
              return res;
            }
          }
          return { kind: "rejected" };
        };

        if (isRedirectEstudante) {
          const estResult = await tentarCascataEstudante();
          if (estResult?.kind === "success" || estResult?.kind === "error") {
            return;
          }
          await tentarLoginEmpresa(usuarioLimpo, senha);
          return;
        }

        // Prioriza /tokens (colaboradores CIEE e empresas) para evitar
        // chamadas 401 desnecessárias nas 3 rotas de login-estudante.
        const empresaResult = await tentarLoginEmpresa(usuarioLimpo, senha, {
          silentReject: true,
        });
        if (
          empresaResult?.kind === "success" ||
          empresaResult?.kind === "error"
        ) {
          return;
        }

        const estResult = await tentarCascataEstudante();
        if (estResult?.kind === "success" || estResult?.kind === "error") {
          return;
        }

        setErrors({
          user: empresaResult?.message || "CPF ou senha inválidos.",
        });
        return;
      }

      await tentarLoginEmpresa(usuarioLimpo, senha);
    } catch (err) {
      console.error("Erro na requisição:", err);
      setErrors({ user: "Erro ao conectar com o servidor." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" id="main-container">
      <form className="form-inicial login-form" onSubmit={entrar}>
        <div id="social_media">
          <img src="/logociee.png" alt="Logo" />
        </div>

        <div className="form_header">
          <h1>Login</h1>
        </div>

        <div id="inputs">
          <div className="input-box">
            <label htmlFor="usuario">CPF ou Código da Empresa</label>
            <div className="input-field">
              <i className="fa-solid fa-user"></i>
              <input
                type="text"
                id="usuario"
                name="usuario"
                className="input-tca"
                placeholder="000.000.000-00"
                maxLength="14"
                autoComplete="username"
                value={usuario}
                onChange={handleUsuarioChange}
                disabled={loading}
              />
            </div>
            <span className="error-message">{errors.usuario}</span>
          </div>

          <div className="input-box">
            <label htmlFor="senha">Senha</label>
            <div className="input-field">
              <i className="fa-solid fa-key"></i>
              <input
                type="password"
                id="senha"
                name="senha"
                placeholder="Senha"
                className="input-tca"
                autoComplete="current-password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                disabled={loading}
              />
            </div>
            <span className="error-message">{errors.senha}</span>
          </div>
        </div>

        <div id="user-error">{errors.user}</div>

        <button
          className={`login${loading ? " login--loading" : ""}`}
          type="submit"
          disabled={loading}
          aria-busy={loading}
        >
          {loading ? (
            <>
              <span className="login__spinner" aria-hidden="true" />
              <span>Acessando...</span>
            </>
          ) : (
            "Acessar"
          )}
        </button>
      </form>
    </div>
  );
};

export default Inicial;
